import { render, staticRenderFns } from "./CommentsWindow.vue?vue&type=template&id=3cadad7c&scoped=true&"
import script from "./CommentsWindow.vue?vue&type=script&lang=js&"
export * from "./CommentsWindow.vue?vue&type=script&lang=js&"
import style0 from "./CommentsWindow.vue?vue&type=style&index=0&id=3cadad7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cadad7c",
  null
  
)

export default component.exports